<template>
  <section class="bg-white rounded mb-2 p-3 p-sm-4">
    <div class="row">
      <div class="col-12 mb-3">
        <h1 class="h2">Your Cart</h1>
        <div role="alert" class="alert alert-warning" v-if="errors">{{ errors }}</div>
      </div>

      <div class="col-12" v-if="committee && product">
        <table class="table table-striped table-bordered border-0"
               v-if="!$store.state.showExpand && cartMembers">
          <thead>
          <tr>
            <th class="position-relative">Committee name</th>
            <th class="position-relative">Type</th>
            <th class="position-relative column-lg-small">Price</th>
            <th class="position-relative column-lg-small"></th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{{ committee.name }}</td>
            <td>{{ product.name }}</td>
            <td>${{ product.price }}</td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <td align="right" colspan="4" class="border-0">
              <strong>Your total: ${{ total.toFixed(2) }}</strong>
            </td>
            <td class="border-0"></td>
          </tr>
          <tr>
            <td align="right" colspan="5" class="border-0">

            </td>
            <td class="border-0"></td>
          </tr>
          </tfoot>
        </table>
      </div>

      <div class="col-12" v-else>
        <div role="alert" class="alert alert-info">Your cart is empty</div>
      </div>

      <div class="col-12 d-flex flex-wrap justify-content-end">
        <router-link tag="button"
                     class="btn btn-block-mob btn-outline-primary order-1 order-lg-0" to="/committees/affiliation">
          Back to Form
        </router-link>
        <button v-if="!!product"
                :class="['btn btn-block-mob btn-primary mb-2 mb-lg-0 ml-lg-2']"
                @click="submit">Proceed to Payment
        </button>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: "CartForm",
  props: ['cartMembers'],
  data() {
    return {
      errors: '',
      committee: ('committee' in this.cartMembers) ? this.cartMembers.committee : null,
      product: ('items' in this.cartMembers) ? this.cartMembers.items[0] : null,
      total: ('total' in this.cartMembers) ? this.cartMembers.total : 0
    }
  },
  methods: {
    submit() {
      this.$router.push('/committees/payment')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Committees/Cart/components/CartForm.vue